window.onload = () => {
  /* Start - Announcement Bar */
  const announcementBar = document.querySelector('.announcement-bar');
  let announcementBarHeight = 0;
  if (announcementBar != null) {
    announcementBarHeight = announcementBar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
  }
  /* End - Announcement Bar */

  /* Start - Sticky Header */
  const header = document.querySelector('.header');
  document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  if (header.classList.contains('header--sticky')) {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;
    
    if (scrollTop > announcementBarHeight) {
      header.classList.add('header--sticky-active');
    }
    
    window.addEventListener('scroll', () => {
      scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop > announcementBarHeight && !header.classList.contains('header--sticky-active')) {
        header.classList.add('header--sticky-active');
      } else if (scrollTop <= 0 && header.classList.contains('header--sticky-active')) {
        header.classList.remove('header--sticky-active');
      }
    });
  }
  /* End - Sticky Header */
  
  /* Start - Mobile Menu */
const headerMobileMenu = document.querySelector('.header--mobile--menu');

if (headerMobileMenu != null) {
  const headerMobileMenuButton = headerMobileMenu.querySelector('.header--mobile--menu-button');
  const headerMobileMenuWrapper = headerMobileMenu.querySelector('.header--mobile--menu-wrapper');
  
  if (headerMobileMenuWrapper != null && headerMobileMenuButton != null) {
    const headerMobileMenuLinks = headerMobileMenuWrapper.querySelectorAll('.header--mobile--menu-main-link');
    const headerMobileMenuSublinks = headerMobileMenuWrapper.querySelectorAll('.header--mobile--menu-main-sublinks-links-link');

    headerMobileMenuButton.addEventListener('click', (e) => {
      e.preventDefault();

      let scrollTop = window.scrollY || document.documentElement.scrollTop;
      
      if (headerMobileMenu.classList.contains('active')) {
        headerMobileMenu.classList.remove('active');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';

        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, scrollTop); // Fixed: use scrollTop instead of scrollY
      } else {
        headerMobileMenu.classList.add('active');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';

        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollTop}px`; // Fixed: use scrollTop instead of scrollY
        document.body.style.width = '100%';
      }
    });
  
    if (headerMobileMenuLinks.length > 0) {
      headerMobileMenuLinks.forEach((headerMobileMenuLink) => {
        const headerMobileMenuLinkDropdown = headerMobileMenuLink.querySelector('.header--mobile--menu-dropdown');
  
        if (headerMobileMenuLinkDropdown != null) {
          headerMobileMenuLinkDropdown.addEventListener('click', (e) => {
            e.preventDefault();
  
            headerMobileMenuLink.classList.toggle('active');
          });
  
          const headerMobileMenuLinkBack = headerMobileMenuLink.querySelector('.header--mobile--menu-main-sublinks-title');
          if (headerMobileMenuLinkBack != null) {
            headerMobileMenuLinkBack.addEventListener('click', (e) => {
              e.preventDefault();
  
              headerMobileMenuLink.classList.remove('active');
            });
          }
        }
      });
    }
    
    if (headerMobileMenuSublinks.length > 0) {
      headerMobileMenuSublinks.forEach((headerMobileMenuSublink) => {
        const headerMobileMenuSublinkContent = headerMobileMenuSublink.querySelector('.header--mobile--menu-main-sublinks-links-links');
        
        // Fixed: Add proper null checks before accessing style and offsetHeight
        if (headerMobileMenuSublinkContent != null) {
          const headerMobileMenuSublinkContentInner = headerMobileMenuSublinkContent.querySelector('.header--mobile--menu-main-sublinks-links-links-content');
          
          if (headerMobileMenuSublinkContentInner != null) {
            headerMobileMenuSublinkContent.style.setProperty('--height', headerMobileMenuSublinkContentInner.offsetHeight + 'px');
          }
        }
        
        const headerMobileMenuSublinkDropdown = headerMobileMenuSublink.querySelector('.header--mobile--menu-main-sublinks-dropdown');
  
        if (headerMobileMenuSublinkDropdown != null) {
          headerMobileMenuSublinkDropdown.addEventListener('click', (e) => {
            e.preventDefault();
  
            headerMobileMenuSublink.classList.toggle('active');
          });
        }
      });
    }
  }
}
/* End - Mobile Menu */
  
  /* Start - Video With Text */
  const videosWithPoster = document.querySelectorAll('.video-with-text--video-poster');

  if (videosWithPoster.length > 0) {
    videosWithPoster.forEach((poster) => {
      poster.addEventListener('click', (e) => {
        const videoContainer = poster.closest('.video-with-text--video');
        const video = videoContainer.querySelector('video');

        videoContainer.classList.remove('video-with-text--video-with-poster');
        video.play();
      });
    });
  }
  /* End - Video With Text */

  /* Start - Cart Page Remove Item */
  const cartRemoveButtons = document.querySelectorAll('cart-remove-button');
  
  if (cartRemoveButtons.length > 0) {
    const cartTotalPrice = document.querySelector('.cart-footer--subtotal span');
    
    cartRemoveButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const item = button.closest('.cart-items--grid');
        item.classList.add('cart-items--grid--loading');
        
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'id': item.dataset.id,
            'quantity': 0
          })
        })
        .then(response => response.json())
        .then(data => {
          item.remove();
          
          cartTotalPrice.innerText = window.Shopify.formatMoney(data.total_price);

          if (data.item_count == 0) {
            const cartEmpty = document.querySelector('.cart-items--empty');
            const cartProducts = document.querySelector('.cart-items--products');
            const cartFooter = document.querySelector('.cart-footer');

            cartProducts.classList.add('hidden');
            cartFooter.classList.add('hidden');
            cartEmpty.classList.remove('hidden');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      })
    });
  }
  /* End - Cart Page Remove Item */

  /* Start - Cart Page Quantity Increase/Decrease */
  const cartQuantityButtons = document.querySelectorAll('cart-quantity-buttons');

  if (cartQuantityButtons.length > 0) {
    const cartTotalPrice = document.querySelector('.cart-footer--subtotal span');
    
    cartQuantityButtons.forEach((quantity) => {
      const input = quantity.querySelector('input');
      const minus = quantity.querySelector('.cart-items--grid-item--quantity-button--minus');
      const plus = quantity.querySelector('.cart-items--grid-item--quantity-button--plus');
      const item = quantity.closest('.cart-items--grid');
      const itemID = item.dataset.id;
      const totalPrice = item.querySelector('.cart-items--grid-item--total');
      const error = item.querySelector('.cart-items-grid-item--error');

      input.addEventListener('focusout', (e) => {
        const val = parseInt(e.target.value);

        item.classList.add('cart-items--grid--loading');
        
        if (val == 0) {
          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'id': item.dataset.id,
              'quantity': 0
            })
          })
          .then(response => response.json())
          .then(data => {
            item.remove();
            
            cartTotalPrice.innerText = window.Shopify.formatMoney(data.total_price);
  
            if (data.item_count == 0) {
              const cartEmpty = document.querySelector('.cart-items--empty');
              const cartProducts = document.querySelector('.cart-items--products');
              const cartFooter = document.querySelector('.cart-footer');
  
              cartProducts.classList.add('hidden');
              cartFooter.classList.add('hidden');
              cartEmpty.classList.remove('hidden');
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        } else {
          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'id': item.dataset.id,
              'quantity': val
            })
          })
          .then(response => response.json())
          .then(data => {
            if (data.status == undefined) {
              cartTotalPrice.innerText = window.Shopify.formatMoney(data.total_price);
              
              const items = data.items;
              items.forEach((item) => {
                if (item.key == itemID) {
                  totalPrice.innerText = window.Shopify.formatMoney(item.final_line_price);
                }
              });
  
              input.dataset.value = val;
              item.classList.remove('cart-items--grid--loading');
              
              if (error.innerText.trim() != '') {
                error.innerText = '';
              }
            } else {
              error.innerText = data.message;
  
              input.value = input.dataset.value;
              item.classList.remove('cart-items--grid--loading');
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      });

      minus.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const val = parseInt(input.value) - 1;
        input.value = val;

        item.classList.add('cart-items--grid--loading');

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'id': item.dataset.id,
            'quantity': val
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status == undefined) {
            cartTotalPrice.innerText = window.Shopify.formatMoney(data.total_price);

            if (val == 0) {
              item.remove();
            } else {
              const items = data.items;
              items.forEach((item) => {
                if (item.key == itemID) {
                  totalPrice.innerText = window.Shopify.formatMoney(item.final_line_price);
                }
              });
  
              input.dataset.value = val;
              item.classList.remove('cart-items--grid--loading');
              
              if (error.innerText.trim() != '') {
                error.innerText = '';
              }
            }
          } else {
            error.innerText = data.message;

            input.value = input.dataset.value;
            item.classList.remove('cart-items--grid--loading');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      });

      plus.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const val = parseInt(input.value) + 1;
        input.value = val;

        item.classList.add('cart-items--grid--loading');

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'id': item.dataset.id,
            'quantity': val
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status == undefined) {
            cartTotalPrice.innerText = window.Shopify.formatMoney(data.total_price);
            
            const items = data.items;
            items.forEach((item) => {
              if (item.key == itemID) {
                totalPrice.innerText = window.Shopify.formatMoney(item.final_line_price);
              }
            });

            input.dataset.value = val;
            item.classList.remove('cart-items--grid--loading');

            if (error.innerText.trim() != '') {
              error.innerText = '';
            }
          } else {
            error.innerText = data.message;

            input.value = input.dataset.value;
            item.classList.remove('cart-items--grid--loading');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      });
    });
  }
  /* End - Cart Page Quantity Increase/Decrease */

  /* Start - Product Page Media */
  const media = document.querySelector('.main-product--media');

  if (media != null) {
    const thumbnails = media.querySelector('.main-product--media-thumbnails');

    const thumbnailsSwiper = thumbnails.querySelector('.main-product--media-thumbnails-swiper');
    if (thumbnailsSwiper != null) {
      window.swiperThumbnails = new Swiper('.main-product--media-thumbnails-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true,
        slideToClickedSlide: true,
        direction: 'vertical',
  
        mousewheel: {
          forceToAxis: true
        }
      });

      window.swiperFeaturedImage = new Swiper('.main-product--media-featured-image-swiper', {
        initialSlide: document.querySelector('.main-product--media-featured-image-swiper').dataset.initialSlide,
        slidesPerView: 'auto',
        spaceBetween: 0,
  
        thumbs: {
          swiper: window.swiperThumbnails
        },
  
        mousewheel: {
          forceToAxis: true
        },

        scrollbar: {
          el: '.swiper-scrollbar',
        },
      });
    }
  }
  /* End - Product Page Media */

  /* Start - Product Page Collapse Text */
  const productCollapseTexts = document.querySelectorAll('.main-product .main-product--info--collapse-text');

  if (productCollapseTexts.length > 0) {
    productCollapseTexts.forEach((productCollapseText) => {
      const content = productCollapseText.querySelector('.main-product--info--collapse-text-content > div');
      const readMore = productCollapseText.querySelector('.main-product--info--collapse-text-read-more a');
  
      productCollapseText.style.setProperty('--height', content.offsetHeight + 'px');
  
      readMore.addEventListener('click', (e) => {
        e.preventDefault();
  
        if (productCollapseText.classList.contains('show')) {
          productCollapseText.classList.remove('show');
          readMore.innerText = 'Read More';
        } else {
          productCollapseText.classList.add('show');
          readMore.innerText = 'Read Less';
        }
      });
    });
  }
  /* End - Product Page Collapse Text */

  /* Start - Product Page Collapse */
  const productCollapses = document.querySelectorAll('.main-product .main-product--info--collapse');

  if (productCollapses.length > 0) {
    productCollapses.forEach((productCollapse) => {
      const button = productCollapse.querySelector('.main-product--info--collapse-button');
      const content = productCollapse.querySelector('.main-product--info--collapse-content');
  
      productCollapse.style.setProperty('--height', content.querySelector('.main-product--info--collapse-content-info').offsetHeight + 'px');
  
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        productCollapse.classList.toggle('show');
      });
    });
  }
  /* End - Product Page Collapse */

 /* Start - Product Page Quantity */
  const quantity = document.querySelector('.main-product .product-form__quantity');

  if (quantity != null) {
    const plusButton = quantity.querySelector('.button--quantity-plus');
    const minusButton = quantity.querySelector('.button--quantity-minus');
    const input = quantity.querySelector('input');

    // Add null checks for all elements
    if (plusButton && minusButton && input) {
      plusButton.addEventListener('click', (e) => {
        e.stopPropagation();

        const qty = parseInt(input.value) + 1;
        input.value = qty;
      });

      minusButton.addEventListener('click', (e) => {
        e.stopPropagation();

        const qty = parseInt(input.value) - 1;
        if (qty >= 1) {
          input.value = qty;
        }
      });
    }
  }
  /* End - Product Page Quantity */

  /* Start - Product Page Add To Cart Button */
  const addToCart = document.querySelector('.main-product .product-form__submit');

  if (addToCart != null) {
    addToCart.addEventListener('click', (e) => {
      const buttonContent = addToCart.querySelector('.button--content');
      const buttonLoading = addToCart.querySelector('.button--loading');

      buttonContent.querySelector('.button--split').classList.add('hidden');
      buttonContent.querySelector('.button--loading').classList.remove('hidden');
    });
  }
  /* End - Product Page Add To Cart Button */

 /* Start - Product Page Variant Picker */
const variantPicker = document.querySelector('.main-product .main-product--info--variant-picker');

if (variantPicker != null) {
  const variants = JSON.parse(variantPicker.querySelector('[data-variants]').innerText);
  const ids = document.querySelectorAll('.main-product [name="id"]');
  const addToCart = document.querySelector('.main-product .product-form__submit');
  const addToCartContent = addToCart.querySelector('.button--split');
  const buttons = variantPicker.querySelectorAll('input[type="radio"]');
  const priceElement = document.querySelector('.main-product--info--price h5');
  const compareAtPriceElement = document.querySelector('.main-product--info--price .compare-at-price');
  let selectedVariant = 0;

  if (buttons.length > 0) {
    buttons.forEach((button) => {
      button.addEventListener('change', (e) => {
        const selectedOptions = variantPicker.querySelectorAll('input[type="radio"]:checked');
        let options = [];
        
        if (selectedOptions[0] != undefined) {
          options.push(selectedOptions[0].value);
        }
        if (selectedOptions[1] != undefined) {
          options.push(selectedOptions[1].value);
        }
        if (selectedOptions[2] != undefined) {
          options.push(selectedOptions[2].value);
        }

        variants.forEach((variant) => {
          if (JSON.stringify(variant.options) == JSON.stringify(options)) {
            selectedVariant = variant;
          }
        });

        if (selectedVariant == 0 || selectedVariant == null) {
          addToCartContent.innerHTML = '<span>Unavailable</span>';
          addToCart.disabled = true;
        } else {
          if (selectedVariant.available == true) {
            addToCartContent.innerHTML = '<span>Add to Cart</span><span><svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.33268 3.81457C4.33268 3.10733 4.61363 2.42905 5.11373 1.92895C5.61382 1.42886 6.2921 1.1479 6.99934 1.1479C7.70659 1.1479 8.38487 1.42886 8.88496 1.92895C9.38506 2.42905 9.66601 3.10733 9.66601 3.81457V4.3479H10.7327V3.81457C10.7327 2.82443 10.3393 1.87484 9.63921 1.17471C8.93907 0.47457 7.98949 0.0812378 6.99934 0.0812378C6.0092 0.0812378 5.05962 0.47457 4.35948 1.17471C3.65934 1.87484 3.26601 2.82443 3.26601 3.81457V4.3479H4.33268V3.81457ZM1.03028 6.8375C1.07385 6.4462 1.26018 6.08469 1.5536 5.82216C1.84703 5.55964 2.22695 5.41452 2.62068 5.41457H11.378C11.7716 5.41478 12.1512 5.56002 12.4444 5.82252C12.7376 6.08502 12.9238 6.44638 12.9673 6.8375L13.7983 14.3042C13.8232 14.5279 13.8006 14.7543 13.7321 14.9687C13.6635 15.183 13.5505 15.3805 13.4004 15.5483C13.2503 15.716 13.0665 15.8501 12.861 15.942C12.6555 16.0338 12.433 16.0813 12.2079 16.0812H1.79081C1.56583 16.0811 1.3434 16.0336 1.13804 15.9416C0.932687 15.8497 0.749023 15.7156 0.59904 15.5479C0.449057 15.3802 0.336127 15.1827 0.267623 14.9684C0.199119 14.7541 0.17658 14.5278 0.201478 14.3042L1.03028 6.8375Z" fill="currentColor"/></svg></span>';
            addToCart.disabled = false;
          } else {
            addToCartContent.innerHTML = '<span>Sold out</span>';
            addToCart.disabled = true;
          }
          
          ids.forEach((id) => {
            id.value = selectedVariant.id;
          });
          
          // Update price using Shopify's formatMoney if available
          if (priceElement) {
            if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney !== 'undefined') {
              priceElement.innerHTML = Shopify.formatMoney(selectedVariant.price, Shopify.money_format);
            } else {
              priceElement.textContent = formatMoney(selectedVariant.price);
            }
          }
          
          // Update compare at price if it exists
          if (compareAtPriceElement) {
            if (selectedVariant.compare_at_price > selectedVariant.price) {
              if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney !== 'undefined') {
                compareAtPriceElement.innerHTML = Shopify.formatMoney(selectedVariant.compare_at_price, Shopify.money_format);
              } else {
                compareAtPriceElement.textContent = formatMoney(selectedVariant.compare_at_price);
              }
              compareAtPriceElement.style.display = '';
            } else {
              compareAtPriceElement.style.display = 'none';
            }
          }

          const preview_image = selectedVariant.featured_media.preview_image.src;
          if (preview_image != undefined && preview_image != null) {
            const featuredImage = document.querySelector('.main-product .main-product--media-featured-image img[src*="' + preview_image + '"]');

            if (featuredImage != null) {
              const slideId = featuredImage.closest('.main-product--media-featured-image').dataset.id;
              
              window.swiperFeaturedImage.slideTo(slideId);
            }
          }

          const mainProductInfo = document.querySelector('.main-product .main-product--info:not(.main-product--info-mobile)');
          window.history.replaceState('', '', mainProductInfo.dataset.url + '?variant=' + selectedVariant.id);
        }
      });
    });
  }
  
  // Helper function for price formatting as fallback
  function formatMoney(cents) {
    cents = cents / 100;
    return '$' + cents.toFixed(2);
  }
}
/* End - Product Page Variant Picker */

  /* Start - FAQ */
  const faqButtons = document.querySelectorAll('.faq .faq--content li .faq--collapse-button');

  if (faqButtons.length > 0) {
    faqButtons.forEach((faqButton) => {
      const li = faqButton.closest('li');
      const content = li.querySelector('.faq--collapse-content');
  
      content.style.setProperty('--height', content.querySelector('.faq--collapse-content-info').offsetHeight + 'px');
  
      faqButton.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        faqButton.classList.toggle('show');
      });
    });
  }
  /* End - FAQ */

  /* Start - Collection Page Filters */
  const filters = document.querySelector('.main-collection--filters');

  if (filters != null) {
    const filtersWrapper = filters.querySelector('.main-collection--filters--wrapper');
    const filtersContainer = filters.querySelector('form');
    const filtersButton = filters.querySelector('.main-collection--filters--mobile .button');

    filtersWrapper.style.setProperty('--height', filtersContainer.offsetHeight + 'px');

    filtersButton.addEventListener('click', (e) => {
      e.preventDefault();

      filtersWrapper.classList.toggle('show');
    });
  }
  /* End - Collection Page Filters */

  /* Start - Product Page Size Chart */
  const sizeChartButton = document.querySelector('.size-chart--button');

  if (sizeChartButton != null) {
    const sizeChart = document.querySelector('.size-chart--modal');
    const sizeChartOverlay = document.querySelector('.size-chart--modal--overlay');
    const sizeChartClose = document.querySelector('.size-chart--modal--close');

    sizeChartButton.addEventListener('click', (e) => {
      e.preventDefault();

      sizeChart.classList.remove('hidden');
    });

    sizeChartOverlay.addEventListener('click', (e) => {
      e.preventDefault();

      sizeChart.classList.add('hidden');
    });

    sizeChartClose.addEventListener('click', (e) => {
      e.preventDefault();

      sizeChart.classList.add('hidden');
    });
  }
  /* End - Product Page Size Chart */

  /* Start - Anchor Links */
  const anchors = document.querySelectorAll('a[href*="#"]');

  if (anchors.length > 0) {
    anchors.forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const href = e.currentTarget.getAttribute('href');
        
        if (href != '#') {
          const checkSection = document.querySelector(href);
          
          if (checkSection != null) {
            e.preventDefault();
  
            checkSection.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start'
            });
          }
        }
      });
    });
  }
  /* End - Anchor Links */

  /* Start - Increase Numbers Animation */
  function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    
    const step = timestamp => {
        startTimestamp || (startTimestamp = timestamp);
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Intl.NumberFormat().format(Math.floor(progress * (end - start) + start)),
        progress < 1 && window.requestAnimationFrame(step)
    };
    
    window.requestAnimationFrame(step);
  }
  
  const numbers = document.querySelectorAll('.number-with-text--block-number');

  if (numbers.length > 0) {
    const numbersWithTextSection = document.querySelector('.numbers-with-text');

    let handleIntersection = function(entries) {
      entries.map(entry => {
        if (entry.intersectionRatio > 0) {
          numbers.forEach((number) => {
            if (!number.classList.contains('entry-init')) {
              const numberText = number.innerText;
              const numberTextMatch = numberText.match(/\d+/g);
  
              number.innerHTML = numberText.replace(numberTextMatch[0], '<span>' + numberTextMatch[0] + '</span>');

              const increaseNumber = parseInt(numberTextMatch[0]);
                increaseNumber > 0 && animateValue(number.querySelector('span'), 0, increaseNumber, 2e3),
                number.classList.add('entry-init');
            }
          });
        }
      })
    };
    
    new IntersectionObserver(handleIntersection, {
      threshold: .5
    }).observe(numbersWithTextSection)
  }
  /* End - Increase Numbers Animation */
}